let logoutTransition = false
const listeners = new Set()

export function isLogoutTransition() {
  return logoutTransition
}

export function beginLogoutTransition() {
  if (logoutTransition) {
    return
  }
  logoutTransition = true
  listeners.forEach((listener) => listener(true))
}

export function subscribeLogoutTransition(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
